module.exports = __webpack_public_path__ + "static/media/CH Headshot.25201c7c.JPG";